import RuleRic9 from './RIC_9'

export default {
  ...RuleRic9,
  gradeLevelId: 10
}
